export function getMinMaxValue<T, K extends keyof T>(arr: T[], key: K): [number, number] {
  const { min, max } = arr.reduce(
    (accumulator, item) => {
      const value: number = item[key] as any;
      if (value < accumulator.min) accumulator.min = value;
      if (value > accumulator.max) accumulator.max = value;
      return accumulator;
    },
    { min: Number.POSITIVE_INFINITY, max: Number.NEGATIVE_INFINITY },
  );
  return [min, max];
}

/**
 * A map function that takes an array, and a mapper function
 * and returns only Truthy values in the resulting array
 *
 * Note: the resulting array will never be LARGER than the input array
 * but it can be SMALLER than the input array, if there are a few Falsy mapped values
 */
export function truthyMap<T, K>(arr: T[], mapperFn: (item: T) => K): K[] {
  return arr.reduce(
    (accumulator, item) => {
      const value = mapperFn(item);
      if (value) accumulator.push(value);
      return accumulator;
    },
    [] as K[],
  );
}
